import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import LeftLayout from "../../../Components/LeftLayout";
// import emailicon from "../../../Images/email.svg";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { Helmet } from "react-helmet-async";
import { useSession } from "../../../authentications/SessionContext";
import ResetPasswordSchema from "../../../utilities/Validation Schema/ResetPasswordSchema";
import { getToken } from "../../../authentications/getCSRFToken";
import LoaderWrapper from "../../../Components/Loader/LoaderWrapper";
import { Formik } from "formik";
import styled from "styled-components";
import { resetPassword } from "../../../authentications/resetPassword";
const FormContainer = styled.form`
display: flex;
flex-direction: column;
justify-content: center;
align-items:center;
margin-top: 100px;
width: 50%;
padding: 33px;

  @media only screen and (max-width: 768px) {
    padding: 18px;
    width: 100%;
`;
const ResetPassword = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [formData, setFormData] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState(null);
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const resetErrorRef = useRef(null);
  const resetRef = useRef(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleBackToSignIn = () => {
    navigate("/signin");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    resetRef.current.disabled = true;
    setIsLoading(true);

    const { email } = formData;
    const cnf_reset_password = true;
    // console.log(
    //   "email,csrf,cnf_reset_password... on submit reset password",
    //   email,
    //   csrfToken,
    //   cnf_reset_password
    // );
    try {
      const result = await resetPassword(email, cnf_reset_password, csrfToken);
      // console.log("result for reset password", result);
      let alertText;
      if (result) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(result, "text/html");
        alertText = doc.querySelector(".alert").textContent.trim();
      }
      // console.log("alertText", alertText);
      if (
        alertText.includes(
          "An email has been sent with credentials to reset your password"
        )
      ) {
        // console.log("success reset password");
        resetErrorRef.current.classList.remove("d-none");
        resetErrorRef.current.classList.remove("alert-danger");
        resetErrorRef.current.classList.add("alert-success");
        resetErrorRef.current.textContent = alertText;
      } else {
        resetErrorRef.current.classList.remove("d-none");
        resetErrorRef.current.classList.remove("alert-success");
        resetErrorRef.current.classList.add("alert-danger");
        resetErrorRef.current.textContent = alertText;
      }
    } catch (error) {
      console.error("An error occurred:", error);
      resetErrorRef.current.classList.remove("d-none");
      resetErrorRef.current.classList.remove("alert-success");
      resetErrorRef.current.classList.add("alert-danger");
      resetErrorRef.current.textContent =
        "An error occurred while authenticating";
    } finally {
      resetRef.current.disabled = false;
      setIsLoading(false);
    }
  };
  const callCSRFApi = async () => {
    try {
      const result = await getToken();
      // console.log("result of csrf token", result);
      if (result.success) {
        setCsrfToken(result.token);
        // console.log("csrfToken", csrfToken);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  useEffect(() => {
    callCSRFApi();
  }, [csrfToken]);
  return (
    <div className="screen_split">
      <Helmet>
        <title>Reset Password | iON Merchant Portal</title>
        <meta name="Reset Password" />
      </Helmet>
      <LeftLayout />
      <LoaderWrapper
        isLoading={!csrfToken}
        height="100vh"
        width="100vw"
      ></LoaderWrapper>
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={ResetPasswordSchema}
        onSubmit={handleSubmit}
      >
        {({
          isSubmitting,
          isValidating,
          touched,
          values,
          errors,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <FormContainer onSubmit={handleSubmit}>
            {console.log(errors, "errors")}
            <div className="forget_password_div">{t["Forget Password"]}?</div>
            <div className="login_text">
              {t["Enter your details to recieve a reset link"]}
            </div>
            {/* <div className="email_Icon">
              <img src={emailicon} alt="emailIcon" />
            </div> */}
            <input
              className={`${isVTEX ? "vtex_forget_input" : "forget_input"}`}
              type="text"
              name="email"
              value={formData.email}
              placeholder={t["Your Email"]}
              onChange={handleInputChange}
              onBlur={async (e) => {
                const { value, name } = e.target;
                setFieldTouched(name, true);
                setErrors({ name: "Email is Required" });
                setFormData({ ...formData, [name]: value });
              }}
            />
            {touched?.email && (
              <span
                style={{
                  textAlign: "left",
                  width: "60%",
                  fontSize: 14,
                  color: "red",
                }}
              >
                {errors.email}
              </span>
            )}
            <div
              ref={resetErrorRef}
              className="col-12 d-none alert"
              role="alert"
              style={{ width: "60%", marginTop: "0.5rem" }}
            ></div>
            <button
              className={`${
                isVTEX ? "vtex_email_button" : "email_button"
              } d-flex align-items-center justify-content-center`}
              type="submit"
              ref={resetRef}
              disabled={
                isLoading || Object.keys(errors).length > 0 || !csrfToken
              }
            >
              {isLoading ? (
                <div className="spinner-border mx-2" role="status"></div>
              ) : (
                ""
              )}
              {!csrfToken ? (
                <span>{t["Please Wait"]}</span>
              ) : (
                <span>{`${t["Verify Email"]}`}</span>
              )}
            </button>
            <div className="login_text">
              {t["Back to"]}{" "}
              <span
                className={`${isVTEX ? "vtex_back_signin" : "back_signin"}`}
                onClick={handleBackToSignIn}
              >
                {t["Sign In"]}
              </span>
            </div>
          </FormContainer>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
